import { render, staticRenderFns } from "./WpPluginStats.vue?vue&type=template&id=e1835944&"
import script from "./WpPluginStats.vue?vue&type=script&lang=js&"
export * from "./WpPluginStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports